import * as infiniteHits from './load_more_results';
import { safeAddWidgets } from './base_widgets';
import { polyfillInitIndex } from './algolia_compat';
import { showModalFromUrl, initializeSaveSearch } from './search_helpers';

window.PublicProjectsSearch = {
  _searchObject: {},
  _userId: null,
  _firstTag: null,

  _initializeSaveSearchEvents() {
    initializeSaveSearch({ type: 'public_projects', showSignInModal: true });
  },

  _searchParameters: {
    facets: ['dynamic_attributes'],
    disjunctiveFacets: ['sectors', 'status_text', 'location', 'height', 'developers', 'consultants', 'contractors', 'suppliers']
  },

  _initFacetsConfig(config) {
    return _.each(config, (key, value) => {
      return this._searchParameters['disjunctiveFacets'].push(key.parentAttribute + '.' + value);
    });
  },

  _setSearchParameters(sectors, tag, userId) {

    if (sectors) {
      this._searchParameters['facetsRefinements'] = { sectors: [sectors] };
    }

    if (tag) {
      const tagAttributeName = `user_tags.${userId}`;
      this._searchParameters['facets'].push(tagAttributeName);
      this._searchParameters['facetsRefinements'] = {};
      return this._searchParameters['facetsRefinements'][tagAttributeName] = [tag];
    }
  },

  _initSearchObject(appId, hitsKey, indexName) {
    const filters = this.initialFilters || PublicIndexesProjectsWidgets.getQuery();
    const client = algoliasearch(appId, hitsKey);
    polyfillInitIndex(client);

    return this._searchObject = instantsearch({
      searchClient: client,
      indexName,
      routing: {
        router: instantsearch.routers.history({
          parseURL({ qsModule, location }) {
            return qsModule.parse(location.search.slice(1), { arrayLimit: Infinity });
          }
        })
      }
    });
  },

  exportProjects(e, url, controller, projectsExportLimit) {
    e.preventDefault();
    const params = controller === 'company_projects' ? CompanyProjects._searchObject.helper.getState() : PublicProjectsSearch._searchObject.helper.getState();

    const url_params = $.param({
      query: params.query,
      filters: params.filters,
      disjunctiveFacetsRefinements: params.disjunctiveFacetsRefinements,
      numericRefinements: params.numericRefinements,
      description: $("#description").is(":checked")
    });

    return window.location = [url, url_params].join('?');
  },

  _initWidgets(view, allowedRegions, showSectors, userId, controller, indexName, prefix, env, isSelfCompany, company, trial, allowedSectors, allowedStatuses, userMembership, highLevelMember, protenders, projectAttributes) {
    const filters = this.initialFilters || PublicIndexesProjectsWidgets.getQuery();
    // configure() has no container — safe to create directly
    const widgets = [
      instantsearch.widgets.configure({
        ...this._searchParameters,
        filters
      })
    ];

    if (view === 'grid') {
      widgets.push(
        () => PublicIndexesProjectsWidgets.hitsWidget(view, userId, controller, userMembership, isSelfCompany, company, trial),
        () => PublicIndexesProjectsWidgets.sortBySelectorWidget(indexName, prefix, env, userMembership, protenders)
      );
    } else if (view === 'map') {
      leafLetMapInit();
      PublicIndexesProjectsWidgets.initAsyncHitsLoading(PublicProjectsSearch, this._searchObject, indexName);
      widgets.push(() => instantsearch.widgets.asyncHitsLoading({ container: '#hits' }));
    } else if (view === 'table') {
      widgets.push(
        () => PublicIndexesProjectsWidgets.paginationWidget(),
        () => PublicIndexesProjectsWidgets.singleHitsWidget(PublicProjectsSearch, view, userId, controller, isSelfCompany, company, trial, userMembership)({}),
        () => AgGridHeadersSearch.initializeHiddenSearchWidget(prefix, indexName, env)
      );
    } else if (view === 'charts') {
      PublicIndexesProjectsWidgets.initAsyncHitsLoadingBreakdown();
      widgets.push(() => instantsearch.widgets.asyncHitsLoadingBreakdown());
    }

    if (showSectors) {
      widgets.push(
        () => PublicIndexesProjectsWidgets.categoryWidget(),
        () => PublicIndexesProjectsWidgets.sectorsWidget(),
        () => PublicIndexesProjectsWidgets.budgetPriceRangeWidget(),
        () => PublicIndexesProjectsWidgets.undisclosedBudgetWidget(),
        () => Widgets.dynamicFacetsWidget(projectAttributes),
        () => PublicIndexesProjectsWidgets.heightWidget(),
        () => PublicIndexesProjectsWidgets.developersWidget(),
        () => PublicIndexesProjectsWidgets.consultantsWidget(),
        () => PublicIndexesProjectsWidgets.contractorsWidget(),
        () => PublicIndexesProjectsWidgets.suppliersWidget(),
        () => PublicIndexesProjectsWidgets.createDateWidget(),
        () => PublicIndexesProjectsWidgets.updateDateWidget(),
        () => PublicIndexesProjectsWidgets.startDateWidget(),
        () => PublicIndexesProjectsWidgets.completionPercentWidget(),
        () => PublicIndexesProjectsWidgets.endDateWidget()
      );

      for (let field of ['design_completed_at.formatted', 'main_contractor_tender_released_at', 'main_contractor_tender_submitted_at', 'main_contractor_awarded_at.formatted', 'mep_contract_awarded_at.formatted', 'construction_started_at']) {
        widgets.push(() => PublicIndexesProjectsWidgets.dateWidget(field));
      }

      widgets.push(() => PublicIndexesProjectsWidgets.clearAllWidget([]));
    } else {
      widgets.push(() => PublicIndexesProjectsWidgets.clearAllWidget(['ended_at']));
    }

    widgets.push(
      () => PublicIndexesProjectsWidgets.quickListWidget(),
      () => Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
      () => PublicIndexesProjectsWidgets.statsWidget()
    );

    if (highLevelMember || ((userMembership === 'insights') && trial)) {
      widgets.push(() => PublicIndexesProjectsWidgets.projectTypeWidget());
    }

    if ((userMembership === 'insights') && trial) {
      widgets.push(() => PublicIndexesProjectsWidgets.trialStatusWidget());
    } else if (showSectors) {
      widgets.push(() => PublicIndexesProjectsWidgets.statusWidget());
    }

    widgets.push(
      () => PublicIndexesProjectsWidgets.searchBoxWidget(I18n.t('projects.keyword_filter.enter_keyword')),
      () => PublicIndexesProjectsWidgets.descriptionWidget(),
      () => PublicIndexesProjectsWidgets.locationWidget(),
      () => PublicIndexesProjectsWidgets.saveSearchWidget()
    );

    if ($('#user-tags').length > 0) {
      widgets.push(() => PublicIndexesProjectsWidgets.userTagsWidget(userId));
    }
    if (protenders) {
      widgets.push(() => PublicIndexesProjectsWidgets.totalScoreRangeWidget());
    }

    safeAddWidgets(this._searchObject, widgets);
  },

  initialize(sectors, allowedRegions, firstTag, tag, view, userId, appId, indexName, showSectors, projectAttributes, controller, highLevelMember, isSelfCompany, company, trial, allowedSectors, allowedStatuses, userMembership, initialFilters, protenders) {
    this._userId = userId;
    this._firstTag = firstTag;
    this.initialFilters = initialFilters;
    this._initFacetsConfig(projectAttributes);
    this._setSearchParameters(sectors, tag, userId);
    this._initSearchObject(appId, hitsKey, indexName);
    this._initWidgets(view, allowedRegions, showSectors, userId, controller, indexName, prefix, env, isSelfCompany, company, trial, allowedSectors, allowedStatuses, userMembership, highLevelMember, protenders, projectAttributes);
    this._initializeSaveSearchEvents();

    this._searchObject.start();
    infiniteHits.loadMoreResults();

    if ($('#projects-grid').length > 0) {
      if (userId) {
        this._searchObject.on('render', function () {
          SearchUtils.adjustViewMode();
          window.advancedSearchFixed();

          return $.cloudinary.responsive();
        });
      } else {
        this._searchObject.on('render', function () {
          window.advancedSearchFixed();

          if (savvior.ready(".ais-Hits-list")) {
            return savvior.destroy();
          } else {
            return setup_gridview();
          }
        });
      }
    }

    return SearchUtils.setUpCustomListsLink('#quick-lists li > .all_list, .liked_list');
  }
};
